/**
 * Styled Components - Created by Jesús Apodaca on 31/10/19.
 */
import styled from 'styled-components'
import Breadcrumb from 'antd/lib/breadcrumb'

interface ItemProps {
  selected?: boolean
}

export const Container = styled(Breadcrumb)`
  align-items: center;
  display: flex;
  font: 400 12px / 20px var(--font-inter);
  gap: 0;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  width: 100%;

  .ant-breadcrumb-separator {
    color: var(--neutral-border-med);
    margin: 0 var(--spacing-8);
  }

  > span > a {
    color: var(--neutral-secondary);

    &:hover {
      color: var(--neutral-secondary);
    }
  }

  > span:last-child > span:not(.ant-breadcrumb-separator) {
    color: var(--neutral-darkest);
    font-weight: 400;
  }

  @media (max-width: 1024px) {
    padding: 16px 24px;
  }
`

export const BreadItem = styled(Breadcrumb.Item)``

export const BreadLabel = styled.span`
  color: ${({ selected }: ItemProps) =>
    selected ? 'var(--neutral-darkest)' : 'var(--neutral-secondary)'};
  font-weight: 400;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/BreadCrumbs/styledComponents.tsx